/* eslint-disable @typescript-eslint/no-unused-vars */
import GenericButton from '@ui-components/Button/GenericButton'
import GenericDropdown from '@ui-components/Dropdown/GenericDropdown'
import { GenericTable } from '@ui-components/Table/GenericTable'
import React, { useState } from 'react'
import { ReactComponent as IconPlus } from "../../../../../shared/assets/Icons/IconPlusV3.svg";
import { Partner } from '../request/request';
import { getPartnerColumns } from './PartnersTableColumns';


export default function PartnerPage() {
        const [partnersList, setPartnersList] = useState<Partner[]>([]);

        //Edit Tenant
        const [isModalOpen, setIsModalOpen] = useState(false);
        const [editMode, setEditMode] = useState(false);

        // Partners
        const [dataCenterOptions, setDataCenterOptions] = useState<string[]>([]);
        const [selectedPartnerName, setSelectedPartnerName] = useState("");

    // ===== 4) HANDLERS =====
	const handlePartnerSelect = (selected: string) => {
		setSelectedPartnerName(selected);
	};

  // 1️⃣ Declare all four handlers:
  const handleViewPartner = (p: Partner) => {
    // e.g. open a view-only drawer, or console.log
    console.log('viewing', p);
  };

  const handleEditPartner = (p: Partner) => {
    setEditMode(true);
    setIsModalOpen(true);
  };

  const handleDeleteClick = (p: Partner) => {
    // call your delete API, then refresh list…
    console.log('deleting', p);
  };


  //Safely pass them into getPartnerColumns:
  const columns = getPartnerColumns({
    handleViewPartner,
    handleEditPartner,
    handleDeleteClick,
  });


    const handleAddHardware = () => {
		setEditMode(false);
		setIsModalOpen(true);
	};
  return (
    <div className="relative">
			{/* 1) SELECT DATACENTER */}
			<div className="mb-4 p-4 bg-[var(--semantic-bg-primary)] border border-semantic-border-secondary rounded-sm">
				<div className="flex items-end justify-between">
					<div className="flex items-end space-x-4">
						<div className="flex flex-col">
							<label className="mb-1 text-sm font-medium text-semantic-text-secondary">
								Select a Partner
							</label>
							<GenericDropdown
								items={dataCenterOptions}
								defaultLabel="Choose DC..."
								value={selectedPartnerName}
								onSelect={handlePartnerSelect}
								minWidthClass="min-w-[200px]"
								maxWidthClass="max-w-[240px]"
							/>
						</div>
					</div>

					<GenericButton
						label={
							<div className="flex items-center gap-2">
								<IconPlus className="w-4 h-4" />
								<span>Create new partner</span>
							</div>
						}
						variant="brand"
						size="md"
						onClick={handleAddHardware}
					/>
				</div>
			</div>

        {/* 2) TABLA PARTNER */}
        <GenericTable
            columns={columns}
            data={partnersList}
            width="100%"
            initialRowsPerPage={5}
            rowsPerPageOptions={[5, 10]}
            tableClassName="bg-semantic-bg-primary"
        />
    </div>
  )
}
